<script setup>
  import { useRoute, useRouter } from 'vue-router'
  import { useAuth } from '@/composables/useAuth'

  const route = useRoute()
  const router = useRouter()
  const { logout } = useAuth()

  function userLogout() {
    logout()
    router.push({
      name: 'login'
    })
  }
  /* 

  const sidebar = document.getElementById('sidebar');
  const menuBtn = document.getElementById('menu-btn');
  

  menuBtn.onclick = () => {
    sidebar.classList.toggle('-translate-x-full');
  }

  */
</script>

<template>
 
  <div class="bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-300">

    <div class="flex h-screen">

      <!-- SIDEBAR (hidden in mobile by default) -->
      <aside id="sidebar" class="fixed md:static top-0 left-0 h-full w-64 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 p-6 transform -translate-x-full md:translate-x-0 transition-transform duration-300 z-50">
        <div class="text-xl font-bold text-[#ff642e] mb-6">Menui</div>
        <nav class="flex flex-col space-y-2">
          <router-link 
            to="/panel/me" 
            class="px-4 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
            :class="route.path.includes('me') ? '!bg-[#ff642e] text-white' : ''"
          >
              Mi marca
          </router-link>
          <router-link 
            to="/panel/orders" 
            class="px-4 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
            :class="route.path.includes('orders') ? '!bg-[#ff642e] text-white' : ''"
          >
              Órdenes
          </router-link>
          <router-link 
            to="/panel/branches" 
            class="px-4 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
            :class="route.path.includes('branches') ? '!bg-[#ff642e] text-white' : ''"
          >
            Sucursales
          </router-link>
          <router-link 
            to="/panel/products" 
            class="px-4 py-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
            :class="route.path.includes('products') ? '!bg-[#ff642e] text-white' : ''"
          >
            Productos
          </router-link>
        </nav>
      </aside>

      <!-- Main Wrapper -->
      <div class="flex-1 flex flex-col h-screen overflow-y-auto">

        <!-- TOP BAR -->
        <header class="flex items-center justify-between px-4 py-4 border-b border-gray-200 dark:border-gray-700 md:hidden">
          <button id="menu-btn" class="text-2xl">☰</button>
          <h1 class="text-xl font-semibold">Mi marca</h1>
        </header>

        <!-- MAIN CONTENT -->
        <main class="flex-1 p-6 space-y-10">
          
          <router-view />
        </main>

      </div>
    </div>

  </div>

</template>


